import createCachedSelector from 're-reselect';
import { getFunctionSensorIds } from '../getFunctionSensorIds';
import { getSensors } from '../getSensors';

export const getInputAndFunctionSensorIds = createCachedSelector(
  [getSensors, getFunctionSensorIds],
  (sensors, ids) => [...sensors, ...ids]
)(
  (state, chartType) => chartType
);